export default __webpack_public_path__ + "static/media/Manrope-ExtraLight.58967406.ttf";